const ProductSpec = (
  t: (str: string, values?: any) => string,
  network_volume: number,
  type: number,
  day?: number | null
): string => {
  let volume = "";
  let days = "";

  if (!network_volume && !type && !day) {
    return "-";
  }

  if (day) {
    days = t("normal.days", { days: day });
  }

  if (network_volume === -1) {
    volume = t("normal.network.no.limit");
  } else if (type === 0) {
    volume = `${t("normal.dailyType.volume", {
      volume: network_volume,
    })}GB`;
  } else {
    volume = `${t("normal.totalType.volume", {
      volume: network_volume,
    })}GB`;
  }

  if (days) {
    return `${volume} / ${days}`;
  }

  return volume;
};

export default ProductSpec;
